import { render, staticRenderFns } from "./CustomMap.vue?vue&type=template&id=3bc6b88a&scoped=true&"
import script from "./CustomMap.vue?vue&type=script&lang=ts&"
export * from "./CustomMap.vue?vue&type=script&lang=ts&"
import style0 from "./CustomMap.vue?vue&type=style&index=0&id=3bc6b88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6b88a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
